import React from 'react';
import { Tag, Button, Space } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

const ActiveAdvancedFilters = ({ filters, onRemoveFilter, onClearAll }) => {
  if (!filters || filters.length === 0) {
    return null;
  }

  const getFilterLabel = (filter) => {
    const fieldLabels = {
      name: 'Nome',
      active: 'Status',
      customers_usage: 'Usado em Clientes'
    };

    const operatorLabels = {
      contains: 'contém',
      not_contains: 'não contém',
      equals: 'é exatamente',
      is_empty: 'está em branco',
      is_not_empty: 'está preenchido',
      is_active: 'é ativo',
      is_inactive: 'é inativo',
      both: 'ambos',
      has_customers: 'tem clientes',
      no_customers: 'não tem clientes',
    };

    const fieldLabel = fieldLabels[filter.field] || filter.field;
    const operatorLabel = operatorLabels[filter.operator] || filter.operator;
    
    if (['is_empty', 'is_not_empty', 'is_active', 'is_inactive', 'both', 'has_customers', 'no_customers'].includes(filter.operator)) {
      return `${fieldLabel}: ${operatorLabel}`;
    }
    
    return `${fieldLabel}: ${operatorLabel} "${filter.value}"`;
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <Space wrap>
        <span style={{ fontWeight: 'bold', color: '#666' }}>Filtros Avançados Ativos:</span>
        {filters.map((filter, index) => (
          <Tag
            key={index}
            closable
            color="blue"
            onClose={() => onRemoveFilter(index)}
            closeIcon={<CloseOutlined />}
          >
            {getFilterLabel(filter)}
          </Tag>
        ))}
        <Button 
          type="link" 
          size="small" 
          onClick={onClearAll}
          style={{ padding: 0, height: 'auto' }}
        >
          Limpar todos
        </Button>
      </Space>
    </div>
  );
};

export default ActiveAdvancedFilters;